import React from "react";
import UserManagement from "./UserMangement";
import UserManagementGrid from "./UsersGrid/UserManagementGrid-container";
import AddEditUser from "./AddEditUser";
import { PivotItem } from "@fluentui/react";

const UserManagementContainer = () => {
  const [selectedKey, setSelectedKey] = React.useState<string>("app-listing");
  const [selectedUserId, setSelectedUser] = React.useState(0);

  const handleLinkClick = (item?: PivotItem) => {
    if (item) {
      setSelectedKey(item.props.itemKey!);
    }
  };

  const tabItems = [
    {
      itemKey: "user-management",
      headerText: "User Management",
      content: (
        <UserManagementGrid
          setSelectedKey={setSelectedKey}
          setSelectedUser={setSelectedUser}
        />
      ),
    },
    {
      itemKey: "add-edit-user",
      headerText: "Add/Edit User Security Role",
      content: <AddEditUser selectedUserId={selectedUserId} setSelectedUser = {setSelectedUser}/>,
    },
  ];
  return (
    <UserManagement
      selectedKey={selectedKey}
      handleLinkClick={handleLinkClick}
      tabItems={tabItems}
    />
  );
};

export default UserManagementContainer;
